import { Alert } from "@heroui/react";
import { IResourceComponentsProps } from "@refinedev/core";
import React from "react";
import { LayoutMessage } from "../../../components/layout/layout-message";
import { SidebarButton } from "../../../components/sidebar/sidebar-menu-button";
import { useAssociationUserShow } from "../../../context/user-show.context";
import { AssociationFeatureFlagEnum } from "../../../lib/association-feature-flag.enum";
import { hasAssociationFeatureFlag } from "../../../lib/utils";

import { CardQrCode } from "./card-qr-code"; // requires a loader
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import { CpgCard } from "./cpg-card";
import { PgaUserCard } from "./pga-user-card";

export const MemberView: React.FC<IResourceComponentsProps> = () => {
  const { associationUser } = useAssociationUserShow();

  if (!associationUser?.association) {
    return (
      <div>
        <LayoutMessage>
          <h1 className="font-bold mb-4">No association found</h1>
        </LayoutMessage>
      </div>
    );
  }
  return (
    // Add justify center to this div to center the swiper
    <div className={"h-full w-full bg-light flex flex-col"}>
      <UserViewHeader />
      {!associationUser?.user?.photoId &&
        !hasAssociationFeatureFlag(
          associationUser?.association,
          AssociationFeatureFlagEnum.CARD_VALID_WITHOUT_IMAGE
        ) && (
          <div className={"p-2 fixed bottom-2 z-10 w-full"}>
            <Alert
              color={"danger"}
              title={"User card is not valid without a profile image."}
            />
          </div>
        )}
      <div className={""}>
        <Swiper
          spaceBetween={15}
          slidesPerView={1.2}
          centeredSlides={true}
          modules={[Pagination]}
          pagination={{
            type: "bullets",
          }}
          cssMode={true}
        >
          <SwiperSlide>
            <CardQrCode />
          </SwiperSlide>
          <SwiperSlide>
            <PgaUserCard />
          </SwiperSlide>
          {(associationUser?.golfClass ||
            associationUser?.coachClass ||
            !!associationUser?.certificates?.length) && (
            <SwiperSlide>{<CpgCard />}</SwiperSlide>
          )}
        </Swiper>
      </div>
    </div>
  );
};

const UserViewHeader = () => {
  return (
    <div className={"flex items-center py-6 px-2 relative justify-self-start"}>
      <SidebarButton additionalClassNames="absolute hover:bg-light focus:bg-light" />
      <div className={"text-center w-full text-xs font-bold tracking-[0.3em]"}>
        VIRTUAL CPG CARD
      </div>
    </div>
  );
};
